import React from 'react';

// Static Assets
import HeroBanner from '../assets/images/Hero-Banner.png';

interface HomeBannerProps {}
interface HomeBannerState {}

class HomeBanner extends React.Component<HomeBannerProps, HomeBannerState> {
  constructor(props: HomeBannerProps) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="home-banner">
          <img src={HeroBanner} className="img-fluid" alt="Hero Banner" />
        </div>
      </>
    );
  }
}

export default HomeBanner;
